import React from 'react'
import RecipeDetail from "./details/RecipeDetails";
import RecipeEdit from "./update/RecipeEdit";
import RecipeDelete from "./delete/RecipeDelete";
import {Button, Popconfirm} from "antd";
import {cloneRecipe} from "../../services/serviceRecipe";

const RecipeActions = ({record, updater}) => {


    const handleCloneClick = () => {
        cloneRecipe({id: record.id})
            .then(() => updater() )
    }

    return (
        <React.Fragment>
            <RecipeEdit recipe={record} updater={updater}/>
            <RecipeDetail recipeId={record.id}/>
            <Popconfirm
                title={'Bu Kayıt İçin Revize Oluşturmak İstiyor musunuz ?'}
                okText={'Onayla'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'primary'}}
                onConfirm={handleCloneClick}
            >
                <Button
                    type={'link'}
                >
                    Revize
                </Button>
            </Popconfirm>
            <RecipeDelete recipe={record} updater={updater}/>
        </React.Fragment>
    )
}
export default RecipeActions